import {
  CREATE_ORDER,
  GET_ALL_ORDER_LIST,
  GET_ALL_ORDER_LIST_SUCCESS,
  GET_ALL_PENDING_ORDER_LIST,
  GET_ALL_PENDING_ORDER_LIST_SUCCESS,
  GET_ALL_CANCELLED_ORDER_LIST,
  GET_ALL_CANCELLED_ORDER_LIST_SUCCESS,
  GET_ORDER_BY_ID,
  GET_ORDER_BY_ID_SUCCESS,
} from '../storeTypes';

const INIT_STATE = {
  loader: false,
  order: [],
  orderDetail: null,
  pendingOrder: [],
  cancelledOrder: [],
};

function OrderHistoryReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case GET_ALL_ORDER_LIST: {
      return {
        ...state,
        order: [],
        loader: true,
      };
    }
    case GET_ALL_ORDER_LIST_SUCCESS: {
      return {
        ...state,
        loader: false,
        order: action.payload,
      };
    }
    case GET_ALL_PENDING_ORDER_LIST: {
      return {
        ...state,
        pendingOrder: [],
        loader: true,
      };
    }
    case GET_ALL_PENDING_ORDER_LIST_SUCCESS: {
      return {
        ...state,
        loader: false,
        pendingOrder: action?.payload,
      };
    }
    case GET_ALL_CANCELLED_ORDER_LIST: {
      return {
        ...state,
        cancelledOrder: [],
        loader: true,
      };
    }
    case GET_ALL_CANCELLED_ORDER_LIST_SUCCESS: {
      return {
        ...state,
        loader: false,
        cancelledOrder: action?.payload,
      };
    }

    case CREATE_ORDER: {
      return {
        ...state,
        loader: true,
      };
    }

    case GET_ORDER_BY_ID: {
      return {
        ...state,
        orderDetail: null,
        loader: true,
      };
    }
    case GET_ORDER_BY_ID_SUCCESS: {
      return {
        ...state,
        loader: false,
        orderDetail: action.payload?.[0],
      };
    }

    default: {
      return state;
    }
  }
}

export default OrderHistoryReducer;
